const formatNumber = (value = "") => {
  const numbers = value.replace(/[^\d]/g, ""); //This strips all characters that aren't digits
  return numbers.substr(0, 3) + "-" + numbers.substr(3, 3) + "-" + numbers.substr(6); //Create format with substrings
}

export default formatNumber;